module.exports = self["window"]["_rm3_shared"]["@tempo-io/roadmapping-frontend-sidebar"];